import { render, staticRenderFns } from "./forms/subject_form.html?vue&type=template&id=16338fdf&"
import script from "./AddSubject.vue?vue&type=script&lang=js&"
export * from "./AddSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports